import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  Chip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Map as MapIcon,
  Route as RouteIcon,
  Traffic as TrafficIcon,
  Warning as IncidentIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { config } from "../config";

function Navigation() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: "Karte", icon: <MapIcon />, path: "/" },
    { text: "Routenplaner", icon: <RouteIcon />, path: "/route" },
    { text: "Verkehrsinfo", icon: <TrafficIcon />, path: "/traffic" },
    { text: "Vorfälle", icon: <IncidentIcon />, path: "/incidents" },
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation">
      <List>
        <ListItem>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Navi App" secondary="Open Source Navigation" />
        </ListItem>

        {menuItems.map((item) => (
          <ListItemButton
            key={item.text}
            selected={location.pathname === item.path}
            onClick={() => handleNavigation(item.path)}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        ))}

        {config.isDevelopment && (
          <ListItem>
            <Chip
              label="Demo-Modus"
              color="warning"
              size="small"
              sx={{ mx: 2, mt: 2 }}
            />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static" color="primary">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Navi - Open Source Navigation
          </Typography>

          {config.isDevelopment && (
            <Chip label="Demo" color="warning" size="small" sx={{ ml: 2 }} />
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default Navigation;
